import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-styled-flexboxgrid'
import system10 from '../../../assets/system10.svg'
import * as styles from './styles'

const propTypes = {
  content: PropTypes.object.isRequired
}

const RpaPageHeader = (props) => {
  const { content } = props
  return (
    <styles.IntroContainer>
      <styles.IntroSection>
        <Row>
          <Col xs={10}>
            <styles.IntroHeader>
              { content.header }
            </styles.IntroHeader>
            <styles.IntroTagline>
              { content.headerInfo }
            </styles.IntroTagline>
            <styles.ButtonContainer>
              <Link to={content.firstButtonUrl}>
                <styles.Button>{content.firstButtonText}</styles.Button>
              </Link>
              <Link to={content.secondButtonUrl}>
                <styles.Button>{content.secondButtonText}</styles.Button>
              </Link>
            </styles.ButtonContainer>
          </Col>
        </Row>
      </styles.IntroSection>

      <styles.IntroSectionSideSquare src={system10} alt="" />
      <styles.IntroSectionBottomSquare src={system10} alt="" />
    </styles.IntroContainer>
  )
}

RpaPageHeader.propTypes = propTypes

export default RpaPageHeader
